import React from 'react';
import PropTypes from 'prop-types';
import EmployeeJobsTable from './employeeJobsTable';
const EmployeeJobs = ({
  jobs: _jobs = []
}) => /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", {
  className: "t-eg-section-jobs"
}, "Associations"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(EmployeeJobsTable, {
  jobs: _jobs
}));
EmployeeJobs.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.shape({}))
};
export default EmployeeJobs;